import angular from 'angular';
import directive from './autocomplete.directive';
import controller from './autocomplete.controller';


export default angular.module('app.components.global.autocomplete', [])
  .directive('ssAutocomplete', directive)
  .controller('AutocompleteController', controller)
  .name;

console.log('app.components.global.autocomplete created');
